package com.essntl.core.utils.repository

sealed interface RealtimeAction<T> {
    data class Insert<T>(val item: T) : RealtimeAction<T>
    data class Update<T>(val item: T) : RealtimeAction<T>
    data class Delete<T>(val itemId: String?) : RealtimeAction<T>
    data class Select<T>(val item: T) : RealtimeAction<T>
}